var _rect, _circle, _circle2, _circle3, _circle4, _path, _mask, _path2, _path3, _circle5, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVidoeParcours(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.98779,
    y: 1,
    width: 29,
    height: 29,
    rx: 6,
    stroke: "#1F2B3C",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5039,
    cy: 15.601,
    r: 3.36735,
    transform: "rotate(58 16.5039 15.601)",
    fill: "#54A8FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5031,
    cy: 15.5992,
    r: 2.17413,
    transform: "rotate(58 16.5031 15.5992)",
    stroke: "white",
    strokeWidth: 0.549695
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1748,
    cy: 25.1772,
    r: 3.36735,
    transform: "rotate(58 40.1748 25.1772)",
    fill: "#54A8FC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1735,
    cy: 25.1754,
    r: 2.17413,
    transform: "rotate(58 40.1735 25.1754)",
    stroke: "white",
    strokeWidth: 0.549695
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 17.0114C20.2343 18.152 22.3126 19.2182 23.0609 18.023C23.8091 16.8277 25.1421 12.4474 25.8747 11.6258C26.6072 10.8042 27.3586 9.87984 28.8239 11.693C30.2892 13.5062 31.3017 16.0571 31.4086 16.627C31.5156 17.1969 31.1006 19.4573 29.9342 20.9139C28.7677 22.3704 26.853 25.0222 27.7115 26.396C28.5699 27.7697 30.3054 26.9581 31.9404 26.1184C33.5753 25.2787 34.8268 27.6803 35.7952 28.1667C36.57 28.5558 37.6901 27.8316 38.1534 27.4208",
    stroke: "#54A8FC",
    strokeWidth: 0.8,
    strokeDasharray: "2 2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_4260_22403",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6827 19.046C46.6642 17.6802 47.1737 15.9663 46.9998 14.1607C46.619 10.2059 43.1043 7.3086 39.1495 7.6894C35.1948 8.07021 32.2975 11.5849 32.6783 15.5397C32.7243 16.0173 32.816 16.4795 32.9486 16.9223C33.7642 20.1417 38.5727 24.9675 40.2565 24.8054C41.499 24.6857 44.1317 22.0105 45.6827 19.046Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6827 19.046C46.6642 17.6802 47.1737 15.9663 46.9998 14.1607C46.619 10.2059 43.1043 7.3086 39.1495 7.6894C35.1948 8.07021 32.2975 11.5849 32.6783 15.5397C32.7243 16.0173 32.816 16.4795 32.9486 16.9223C33.7642 20.1417 38.5727 24.9675 40.2565 24.8054C41.499 24.6857 44.1317 22.0105 45.6827 19.046Z",
    fill: "#54A8FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6827 19.046L45.4149 18.8535L45.4013 18.8725L45.3904 18.8931L45.6827 19.046ZM32.9486 16.9223L33.2683 16.8413L33.2666 16.8345L33.2646 16.8277L32.9486 16.9223ZM46.6715 14.1923C46.8374 15.9154 46.3515 17.5502 45.4149 18.8535L45.9505 19.2385C46.9769 17.8103 47.5099 16.0172 47.3281 14.129L46.6715 14.1923ZM39.1811 8.0177C42.9546 7.65436 46.3081 10.4188 46.6715 14.1923L47.3281 14.129C46.9298 9.99296 43.254 6.96285 39.1179 7.36111L39.1811 8.0177ZM33.0066 15.5081C32.6432 11.7346 35.4077 8.38105 39.1811 8.0177L39.1179 7.36111C34.9818 7.75937 31.9517 11.4352 32.35 15.5713L33.0066 15.5081ZM33.2646 16.8277C33.138 16.4053 33.0505 15.9642 33.0066 15.5081L32.35 15.5713C32.398 16.0704 32.4939 16.5537 32.6327 17.017L33.2646 16.8277ZM40.2248 24.4771C40.0923 24.4899 39.8917 24.4544 39.6194 24.3409C39.3527 24.2296 39.0439 24.0547 38.7054 23.8227C38.0289 23.3591 37.2618 22.687 36.5157 21.9043C35.0132 20.3284 33.655 18.3675 33.2683 16.8413L32.6289 17.0033C33.0578 18.6965 34.5116 20.7582 36.0382 22.3595C36.8066 23.1655 37.6083 23.8706 38.3325 24.3668C38.6943 24.6148 39.0438 24.8155 39.3655 24.9497C39.6816 25.0815 39.9997 25.1615 40.2881 25.1337L40.2248 24.4771ZM45.3904 18.8931C44.6301 20.3464 43.6027 21.7314 42.6154 22.7647C42.1218 23.2813 41.6439 23.704 41.2205 24.0022C40.7866 24.3078 40.4474 24.4557 40.2248 24.4771L40.2881 25.1337C40.6868 25.0953 41.1426 24.8639 41.6003 24.5415C42.0684 24.2119 42.5786 23.758 43.0924 23.2203C44.1199 22.1449 45.1843 20.71 45.9749 19.1989L45.3904 18.8931Z",
    fill: "white",
    fillOpacity: 0.8,
    mask: "url(#path-7-inside-1_4260_22403)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5334,
    cy: 14.8797,
    r: 2.90816,
    transform: "rotate(-5.5 39.5334 14.8797)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6407 8.90928L10.4109 6.51808L8.0615 8.70893L10.2913 11.1001L9.32392 12.0022L13.7654 12.2765L13.8016 7.82674L12.6407 8.90928Z",
    fill: "#54A8FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6258 22.6356L22.7959 24.9627L25.204 22.717L23.034 20.39L24.0256 19.4653L19.5872 19.3065L19.4359 23.7452L20.6258 22.6356Z",
    fill: "#54A8FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2609 11.7158L24.6001 9.53443L22.4092 7.18504L20.07 9.36639L19.1679 8.39899L18.945 12.7926L23.3434 12.8767L22.2609 11.7158Z",
    fill: "#54A8FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59406 19.7078L7.32375 21.8249L9.5146 24.1743L11.7849 22.0572L12.687 23.0246L12.8419 18.6945L8.51152 18.547L9.59406 19.7078Z",
    fill: "#54A8FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVidoeParcours);
export default __webpack_public_path__ + "static/media/icon_vidoe_parcours.46cc028c.svg";
export { ForwardRef as ReactComponent };